import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import { focusTrap, getFirstFocusableEl } from "../../helpers";

import * as Styled from "./Modal.styled";

const Modal = ({ onClose, isOpen, children, fullScreenModal }) => {
    const [initalFocusedEl, setInitalFocusedEl] = useState(null);
    const modalEl = useRef(null);

    useEffect(() => {
        const onEscape = e => e.key === "Escape" && isOpen ? onClose() : null;
        document.addEventListener("keydown", onEscape);
        return () => {
            document.removeEventListener("keydown", onEscape);
        };
    }, [onClose]);

    useEffect(() => {
        if (isOpen) {
            const { activeElement } = document;
            const firstFocusableEl = getFirstFocusableEl(modalEl.current);
            setInitalFocusedEl(activeElement);
            if(firstFocusableEl) setTimeout(() => firstFocusableEl.focus(), 100);    
        } else {
            if (initalFocusedEl?.tagName === "BODY") {
                const firstFocusableEl = getFirstFocusableEl(initalFocusedEl);
                firstFocusableEl?.focus();
            } else {
                initalFocusedEl?.focus();
            }
        };
    }, [isOpen]);

    return (
        <Styled.Backdrop isOpen={isOpen} fullScreenModal={fullScreenModal}>
            <Styled.Modal onKeyDown={e => focusTrap(e)} ref={modalEl}>
                {children}
            </Styled.Modal>
        </Styled.Backdrop>
    );
};

export default Modal;

Modal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    children: PropTypes.node,
    fullScreenModal: PropTypes.bool
};
